// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  envName: 'beta',
  endpointJson: 'https://beta-apac-ap-southeast-1-s3-config.s3-ap-southeast-1.amazonaws.com/config-internal.json',
  configBasePath: 'https://beta-apac-ap-southeast-1-s3-config.s3-ap-southeast-1.amazonaws.com',
  cesAPI: {
    apiKey: 'tasSilW1Ig7wcwvZ9fZiW95K93iT9wSZxK7Zywd6'
  },
  cognito: {
    userPoolId: 'ap-southeast-1_9IoZ7cNUV',
    clientId: '59v87obus59eb1qlpp1k4sc62s',
    identityPoolId: 'ap-southeast-1:ef482e38-bdab-47f5-9f22-1e732d21f1f2',
    region: 'ap-southeast-1',
    idpUrl: 'login.microsoftonline.com/548d26ab-8caa-49e1-97c2-a1b1a06cc39c',
    azureAppId: 'af5baeee-b071-4a2f-a60d-a9bf426c841f',
  },
  siteUrl: 'https://dash-management.beta.apac.gcds.coke.com/',
  internalHost: 'beta.apac-internal.gcds.coke.com',
  publicHost: 'beta.apac.gcds.coke.com',
  dashOnly: true
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts